import { useState, useContext } from "react";
import { FaBars } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import logo from "../../assets/images/logo.png";

export const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { handleLogout } = useContext(AppContext);

  const token = localStorage.getItem("accessToken");
  const name = localStorage.getItem("name");
  const role = localStorage.getItem("role");
  const profilePicture = localStorage.getItem("profilePicture");
  const occupation = localStorage.getItem("occupation");

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const navigateToDashboard = () => {
    if (role === "SUPER_ADMIN") {
      navigate("/all-users");
    } else {
      navigate("/user-profile");
    }
  };

  const navigateToMagazine = () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      navigate("/magazines");
    } else {
      navigate("/login");
    }
  };

  const navigateToPublish = () => {
    if (occupation === "Product") {
      navigate("/add-new-product");
    } else {
      navigate("/add-new-project");
    }
  };

  const navigateToSuperAdminScreen = () => {
    navigate("/all-users");
  };

  return (
    <>
      <div>
        {/* Desktop Navbar */}
        <div className="flex sticky h-16 items-center gap-6 justify-end bg-neutral-900  text-sm font-normal text-gray-200 sm:px-6 lg:px-40">
          <div className="flex items-center gap-6 mt-5 mb-5">
            <button
              type="button"
              className="px-3 py-2 me-2  text-sm font-medium text-white focus:outline-none  rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-900 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
            >
              Book
            </button>
            <button
              type="button"
              className="px-3 py-2 me-2  text-sm font-medium text-white focus:outline-none  rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-900 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
              onClick={navigateToMagazine}
            >
              Magazine
            </button>

            {token ? (
              <>
                <div className="flex items-center gap-2 relative">
                  <button
                    type="button"
                    className="px-3 py-2 me-2  text-sm font-medium text-white focus:outline-none  rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-900 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                    onClick={navigateToDashboard}
                  >
                    Dashboard
                  </button>

                  <div className="flex items-center gap-4">
                    <img
                      className="relative inline-block h-10 w-10 !rounded-full  object-cover object-center"
                      src={profilePicture}
                      alt="Rounded avatar"
                    />
                    <div className="flex flex-col items-center text-sm">
                      <p className="font-semibold">Welcome, {name}</p>

                      <p
                        className="text-xs flex items-center gap-1 text-red-400 cursor-pointer"
                        onClick={handleLogout}
                      >
                        <IoMdLogOut /> Sign Out
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <button
                type="button"
                className="px-3 py-2 me-2  text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-800 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                onClick={() => navigate("/login")}
              >
                Log In
              </button>
            )}
          </div>
        </div>

        {/* Mobile Navbar */}
        <div className="sm:hidden  px-4 py-2 flex justify-between items-center">
          <Link to="/">
            <img
              src={logo}
              className="w-20"
              alt="logo-balarch"
            />
          </Link>
          <FaBars
            className="text-gray-800 text-2xl cursor-pointer"
            onClick={toggleMobileMenu}
          />
        </div>

        {/* Mobile Menu Popup */}
        {isMobileMenuOpen && (
          <div className="sm:hidden fixed inset-0 bg-gray-900 bg-opacity-75 z-50">
            <div className="flex flex-col items-center justify-center h-full">
              <NavLink
                to="/projects"
                className="text-gray-200 text-xl py-2"
                onClick={toggleMobileMenu}
              >
                PROJECTS
              </NavLink>
              <NavLink
                to="/professionals"
                className="text-gray-200 text-xl py-2"
                onClick={toggleMobileMenu}
              >
                PROFESSIONALS
              </NavLink>
              <NavLink
                to="/product-profile"
                className="text-gray-200 text-xl py-2"
                onClick={toggleMobileMenu}
              >
                PRODUCTS
              </NavLink>
              <NavLink
                to="/all-users"
                className="text-gray-200 text-xl py-2"
                onClick={toggleMobileMenu}
              >
                PUBLISH
              </NavLink>
            </div>
          </div>
        )}

        {/* Desktop Navigation Links */}
        <div className="py-5 flex items-center justify-center text-gray-900 font-bold gap-24 hidden sm:flex">
          <NavLink
            to="/projects"
            className={({ isActive }) =>
              isActive
                ? "underline underline-offset-8"
                : "hover:underline hover:underline-offset-8"
            }
          >
            PROJECTS
          </NavLink>
          <NavLink
            to="/professionals"
            className={({ isActive }) =>
              isActive
                ? "underline underline-offset-8"
                : "hover:underline hover:underline-offset-8"
            }
          >
            PROFESSIONALS
          </NavLink>

          <Link to="/">
            <img
              src={logo}
              className="w-40"
              alt="logo-balarch"
            />
          </Link>
          <NavLink
            to="/product-profile"
            className={({ isActive }) =>
              isActive
                ? "underline underline-offset-8"
                : "hover:underline hover:underline-offset-8"
            }
          >
            PRODUCTS
          </NavLink>
          {token ? (
            role === "SUPER_ADMIN" ? (
              <button
                type="button"
                className="hover:underline hover:underline-offset-8"
                onClick={navigateToSuperAdminScreen}
              >
                PUBLISH
              </button>
            ) : (
              <button
                type="button"
                className="hover:underline hover:underline-offset-8"
                onClick={navigateToPublish}
              >
                PUBLISH
              </button>
            )
          ) : (
            <Link
              to="/login"
              className={({ isActive }) =>
                isActive
                  ? "underline underline-offset-8"
                  : "hover:underline hover:underline-offset-8"
              }
            >
              PUBLISH
            </Link>
          )}
        </div>
      </div>
    </>
  );
};
